module.exports = __webpack_public_path__ + "img/10-min.fac8e404.jpg";